import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { fmtDate } from "../lib/format";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/blog").then(({ data }) => setPosts(data)).catch(() => {}); }, []);
  return (
    <div data-testid="blog-page" className="max-w-7xl mx-auto px-4 py-10">
      <h1 className="font-serif text-3xl sm:text-4xl text-forest">Blog</h1>
      <p className="text-stone-500 mt-2">Doğal ürünler, yöresel lezzetler ve sağlıklı yaşam üzerine yazılar</p>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-10">
        {posts.map((p) => (
          <Link key={p.post_id} to={`/blog/${p.slug}`} data-testid={`blog-post-${p.slug}`} className="group bg-white rounded-2xl border border-stone-200/80 overflow-hidden shadow-sm hover:shadow-md transition-shadow">
            <div className="aspect-[16/10] overflow-hidden"><img src={p.image} alt={p.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" /></div>
            <div className="p-5">
              <div className="flex items-center gap-3 text-xs"><span className="uppercase tracking-widest text-gold-dark font-semibold">{p.category}</span><span className="text-stone-400">{fmtDate(p.published_at)}</span></div>
              <h2 className="font-semibold text-stone-900 mt-2 leading-snug group-hover:text-forest transition-colors">{p.title}</h2>
              <p className="text-sm text-stone-500 mt-2 line-clamp-2">{p.excerpt}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
